export default "/images/vendor/flag-icon-css/flags/1x1/tz.svg?148d6a2535c91c0c7922e03abc865cec";